import { List } from 'immutable'
import { HttpResult } from 'widgets-for-react'
import { Locale, Pager, PaginatedItem } from '../../drupal/types_and_parser/extra_types.mod'
import { node_story_guard, node_story_parser } from '../../drupal/types_and_parser/parser'
import { allLanguages, defaultLanguage } from '../utils/history.mod'

export async function getOverview<T>(
  api_name: string,
  lang: string,
  page?: number,
  taxonomy?: 'all' | string
): Promise<HttpResult<PaginatedItem<T>>> {
  const locale = getLanguage(lang)

  const res = await fetch(
    `/api/drupal${locale == 'global' ? '' : `/${locale}`}/api/${api_name}${
      taxonomy != undefined && taxonomy != 'all' ? `/${taxonomy}` : ``
    }${page != null ? `?page=${page}` : ''}`
  )

  if (!res.ok) return { kind: 'failed', status: 400 }

  const type_parser = (t: any) => (node_story_guard(t) ? node_story_parser(t) : null)

  const json = await res.json()
  const pager = json['pager'] as Pager
  const items = json['items']

  let parsed: PaginatedItem<T>

  if (Array.isArray(json)) parsed = { pager: pager, items: List<T>(json.map((j) => type_parser(j))) }
  else if (Array.isArray(items)) parsed = { pager: pager, items: List<T>(items.map((j) => type_parser(j))) }
  else parsed = { pager: pager, items: List<T>(type_parser(items)) }
  return { kind: 'result', status: 200, value: parsed }
}

const getLanguage = (lang: string): Locale => allLanguages.find((l) => l === lang) || defaultLanguage
